import React from 'react';
import styled from '@emotion/styled';
import { Box, Stack, Flex } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../../constants/styles';

const StyledLoader = styled.div`
  margin-top: 20px;
`;

export const BillingProfileCardsLoader = () => {
  const renderBoxContent = () => {
    const marginBottom = '0';

    return (
      <Box padding="space.200" xcss={boxStyles}>
        <SkeletonLoaderWrapper>
          <Flex justifyContent="space-between" alignItems="center">
            <SkeletonLoader width="20%" marginBottom={marginBottom} />
            <SkeletonLoader width="30%" marginBottom={marginBottom} />
            <SkeletonLoader width="30%" marginBottom={marginBottom} circle={true} />
            <SkeletonLoader width="30%" marginBottom={marginBottom} />
          </Flex>
        </SkeletonLoaderWrapper>
      </Box>
    );
  };

  const renderContentLoaders = () => {
    return <Stack grow="fill">{Array.from({ length: 3 }).map((_) => renderBoxContent())}</Stack>;
  };

  return (
    <div data-testid="select-billing-profile-loader">
      <StyledLoader>
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="20%" />
        </SkeletonLoaderWrapper>
        {renderContentLoaders()}
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="20%" />
        </SkeletonLoaderWrapper>
        {renderContentLoaders()}
      </StyledLoader>
    </div>
  );
};
